import isEmpty from 'lodash/isEmpty';
import { IComparisonPopulationSetting } from '../settings/comparisonPopulationSettingsProvider';
import { isValidDateRange } from './isValidDateRange';

/**
 * @description evaluates a comparsion population to make sure the necessary properties have values
 * @param population
 * @returns
 */
export const isValidComparisonPopulation = (
  population: IComparisonPopulationSetting,
  ignoreZScore?: boolean
): boolean => {
  /// make sure its defined
  if (isEmpty(population)) return false;
  /// make sure the data range is valid
  if (
    !isValidDateRange({
      dateType: population?.dateRangeType,
      dateRange: population?.dateRangeValues,
    })
  ) {
    return false;
  }
  /// make sure the entity is valid
  if (isEmpty(population?.entity)) return false;
  /// make sure the zscore preference is valid
  if (!ignoreZScore) {
    if (isEmpty(population?.zScorePreference)) {
      return false;
    }
  }

  return true;
};
